import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import OpcoesFiltroPor from "./Component/OpcoesFIltroPor";
import ButtonHandle from "./Component/ButtonHandle";
import MonthYearPicker from "../../../../components/MonthYearPicker";
import ConvertDataService from '../../../../services/util/ConvertDatas';


/**
 * Mordal de filtros
 *
 * @param {string} buttonHandle - Passar o nome do modal para definir os dados a serem retornados ao enviar o form.
 * @param {Object} clientes - Passar lista de clientes.
 * @param {Object} projetos - Passar lista de projetos.
 * @param {boolean} habilitarTipoCusto - Ao passar true, exibe o campo de seleção de tipo de custo.
 * @param {boolean} habilitarMultiSelect - Ao passar true, exibe o select do tipo multiplo para seleção de projetos.
 * @param {boolean} habilitarDataMeses - Ao passar true, muda para o formato de data por meses, false muda para somente o ano.
 * @param {boolean} habilitarRadioTotalOuData - Ao passar true, exibe o radio de total ou data, false existe somente a data.
 * @returns Componente do modal usada no filtro da pagina Relatorio Delivery.
 */

export default function FiltroResultadosDoCliente (props) {
    const [radioPeriodo, setRadioPeriodo] = useState("");
    const [radioFiltrarPor, setRadioFiltrarPor] = useState("");
    const [dataFinal, setDataFinal] = useState(new Date());
    const [dataInicial, setDataInicial] = useState(new Date());
    const [anoSelecionado, setAnoSelecionado] = useState("");
    const [clienteSelecionado, setClienteSelecionado] = useState("");
    const [clienteSelecionadoNome, setClienteSelecionadoNome] = useState("");
    const [liderSelecionado, setLiderSelecionado] = useState("");
    const [liderSelecionadoNome, setLiderSelecionadoNome] = useState("");

    const handleRadioPeriodo = (event) => {
        setRadioPeriodo(event.target.value);
    };

    const handleRadioFiltrarPor = (event) => {
        setRadioFiltrarPor(event.target.value);
        // Limpa as seleções quando muda o tipo de filtro
        setClienteSelecionado("");
        setClienteSelecionadoNome("");
        setLiderSelecionado("");
        setLiderSelecionadoNome("");
    };

    useEffect(() => {
        if (radioPeriodo === "total") {
            setAnoSelecionado("total");
        } else {
            setAnoSelecionado("");
        }
    }, [radioPeriodo]);

    return (
        <>
            <span style={{ fontSize: "12px" }}>* Campo obrigatório</span>
            <Form className="mt-3">
                {props.habilitarRadioTotalOuData && (
                    <Form.Group>
                        <Form.Label>Período: *</Form.Label>
                        <Form.Check
                            type="radio"
                            label="Total"
                            name="radioGroupPeriodo"
                            id="por-total"
                            value="total"
                            checked={radioPeriodo === 'total'}
                            onChange={handleRadioPeriodo}
                        />
                        <Form.Check
                            type="radio"
                            label="Data/Ano"
                            name="radioGroupPeriodo"
                            id="por-data"
                            value="data"
                            checked={radioPeriodo === 'data'}
                            onChange={handleRadioPeriodo}
                        />
                    </Form.Group>
                )}

                {(!props.habilitarRadioTotalOuData || radioPeriodo === 'data') && (
                    <>
                        {props.habilitarDataMeses ? (
                            <div className='d-flex'>
                                <Form.Group className='d-flex flex-column mr-3'>
                                    <Form.Label>Período inicial: </Form.Label>
                                    <MonthYearPicker setMonthYear={setDataInicial} monthYear={dataInicial} />
                                </Form.Group>
                                <Form.Group className='d-flex flex-column mr-3'>
                                    <Form.Label>Período final: </Form.Label>
                                    <MonthYearPicker setMonthYear={setDataFinal} monthYear={dataFinal} />
                                </Form.Group>
                            </div>
                        ) : (
                            <Form.Group className='mr-3'>
                                <Form.Label>Ano</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="ano"
                                    onChange={(e) => setAnoSelecionado(e.target.value)}
                                >
                                    <option value="">Selecione</option>

                                    {ConvertDataService.getAnos().map(ano => (
                                        <option key={ano} value={ano}>{ano}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        )}
                    </>
                )}

                <Form.Group>
                    <Form.Label>Filtrar por: *</Form.Label>
                    <Form.Check
                        type="radio"
                        label="Cliente"
                        name="radioGroupFiltrarPor"
                        id="por-cliente"
                        value="cliente"
                        checked={radioFiltrarPor === 'cliente'}
                        onChange={handleRadioFiltrarPor}
                    />
                    <Form.Check
                        type="radio"
                        label="Líder"
                        name="radioGroupFiltrarPor"
                        id="por-lider"
                        value="lider"
                        checked={radioFiltrarPor === 'lider'}
                        onChange={handleRadioFiltrarPor}
                    />
                </Form.Group>

                {radioFiltrarPor === 'cliente' && (
                    <Form.Group>
                        <Form.Label>Selecione o cliente: *</Form.Label>
                        <Form.Control
                            as="select"
                            name="clientes"
                            onChange={(e) => {
                                setClienteSelecionado(e.target.value);
                                const cliente = props.clientes.find(c => c.id == e.target.value);
                                setClienteSelecionadoNome(cliente ? cliente.nome : "");
                            }}
                        >
                            <option>--Selecione o cliente--</option>
                            {props.clientes
                                .slice()
                                .sort((a, b) => a.nome.localeCompare(b.nome))
                                .map((item, index) => (
                                    <option value={item.id} key={index}>{item.nome}</option>
                                ))
                            }
                        </Form.Control>
                    </Form.Group>
                )}

                {radioFiltrarPor === 'lider' && (
                    <Form.Group>
                        <Form.Label>Selecione o líder: *</Form.Label>
                        <Form.Control
                            as="select"
                            name="lideres"
                            onChange={(e) => {
                                setLiderSelecionado(e.target.value);
                                setLiderSelecionadoNome(e.target.value);
                            }}
                        >
                            <option>--Selecione o líder--</option>
                            {props.lideres
                                .slice()
                                .sort((a, b) => a.lead.localeCompare(b.lead))
                                .map((item, index) => (
                                    <option value={item.lead} key={index}>{item.lead}</option>
                                ))
                            }
                        </Form.Control>
                    </Form.Group>
                )}

                <ButtonHandle
                    buttonHandle={props.buttonHandle}
                    handleDados={props.handleDados}
                    anoSelecionado={anoSelecionado}
                    dataInicial={dataInicial}
                    dataFinal={dataFinal}
                    clienteSelecionado={clienteSelecionado}
                    radioPeriodo={radioPeriodo}
                    clienteSelecionadoNome={clienteSelecionadoNome}
                    radioFiltrarPor={radioFiltrarPor}
                    liderSelecionado={liderSelecionado}
                    liderSelecionadoNome={liderSelecionadoNome}
                />

            </Form>
        </>
    );
}